<template>
  <li>
    <div class="row">
      <div class="col-xs-3">
        <div class="avatar">
          <img
            src="img/Friends/guy-2.jpg"
            alt="Circle Image"
            class="img-circle img-no-padding img-responsive"
          />
        </div>
      </div>
      <div class="col-xs-6">Carlos marthur</div>

      <div class="col-xs-3 text-right">
        <button class="btn btn-sm btn-azure btn-icon"
          ><i class="fa fa-user-plus"></i
        ></button>
      </div>
    </div>
  </li>
</template>